import React, { useState } from 'react';
import styled from 'styled-components'
import Utils from './Utils'
import PageWrapper from './PageWrapper'
import { GridspaceLoadingIcon } from './Components';

import { InputFields, SessionForm, SessionTextArea, NumberTextArea, FormField, SubmitRow, MultiLineText, RowFlexDiv, ColFlexDiv } from './Components'


function jsonEscape(str)  {
  return str.replace(/\n/g, "\\\\n").replace(/\r/g, "\\\\r").replace(/\t/g, "\\\\t").replaceAll("&#34;", "\"").replaceAll("&#39;", "\'")
}

const ModalWrapper = styled.div`
  display: ${props => (props.isOpen ? 'flex' : 'none')};
  justify-content: right;
  align-items: center;
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
  width: 40%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
`;

const ModalContent = styled.div`
  background-color: white;
  border: 1px solid #888;
  padding: 20px;
  width: 80%;
  border-radius: 3px;
  margin: 5%;
  max-height: 80vh; /* Set the maximum height */
  overflow-y: auto; /* Enable vertical scrolling */
`;

const CloseButton = styled.span`
  color: #aaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
  cursor: pointer;

  &:hover,
  &:focus {
    color: black;
    text-decoration: none;
  }
`;

const OpenButton = styled.button`
  background-color: #D5DCE07D;
  cursor: pointer;
  position: fixed;
  top: 100px; /* Adjust this value as needed */
  left: 20px; /* Adjust this value as needed */

  &:hover,
  &:focus {
    background-color: #204860;
    text-decoration: none;
  }
`;

const TaskSpecInstructions = 
<ul>

<li><strong>What do I do now?</strong>Click 'edit_taskspec' to open the edit form, then save it before submitting it to slack</li>
<li><strong>Data Input Format</strong>
  <ul>
    <li>
      Input data should exist in a bucket and be of the format of json or jsonl files. If you use jsons, it is assumed each json is a separate datapoint, and the datapoint_id will be the filename (e.g. LM Logs). If you use jsonl, each newline is a datapoint and you must provide unique datapoint_ids. 
    </li>
    <li>
      Each datapoint in the input dataset should contain a dictionary with the following fields:
      <ul>
      <li>
        <strong>datapt_id</strong> - unique identifier for that datapoint
      </li>
      <li>
        <strong>original_datapt</strong> - the datapoint itself (can be internal/not pretty, such as raw prompts/logs. Does not have to make sense to labeller, but is whatever the datapoint needs to be a useful datapoint in the dataset)
      </li>
      <li>
        <strong>context_for_labeller</strong> - what gets displayed to the labeller. Should be curated/pretty/make sense to a human. Should contain all the information they need to label this point.
      </li>
      <li>
        <strong>audiofiles</strong> (optional) - Any files they need to complete the datapoint, as GCP file locations (e.g. audio files for transcription, but can be any filetype tbh)
      </li>
      </ul>
    </li>
    <li>
      LM Logs can ommit some of the necessary fields as we know what their format is. They Can contain 
    </li>
    <li><strong>Data Output Format</strong> - eachd atapoint is svaed as a json in the output bucket, with additional 'num_labels' and human_labels' fields</li>
  </ul></li>

<li><strong>Task ID: </strong>Give the task a simple name that won't screw up JSON.</li>
<li><strong>Instructions: </strong>Put in some instructions for the task. The mixers will see this once at the beginning of the task and it can be asked for in the middle of a task through the chat format.</li>
<li><strong>input_file_pattern: </strong>Input file pattern is a glob pattern for the input data. It has to be a bucket mixer has access to. The whole bucket will be labeled for now.</li>
<li><strong>Sampling Percentage: </strong>Value 0-1, What percentage of the input dataset you want labelled (useful for large input buckets where you just need a subset)</li>

<li><strong>Slack Response Format: </strong> Choose how you want to collect responses
<ul>
  <li><strong>Chat: </strong>Submissions are text-only and are submitted through the chat interface and a message to the slack bot. Runs the risk of confusion, not recommended outside of special cases.</li>
  <li><strong>Block Submit: </strong>Submissions are in separated into forma fields and then submitted through a 'submit' button. Can support multiple formats (text, checkboxes, etc) and multiple labels per datapoint. Generally more applicable. If you're new, use this as the default.</li>
</ul>
</li>
<li><strong>Slack Task Serving Format: </strong>Choose how you want to show the tasks to the labellers (only applicable to 'block submit', 'chat' tasks are implictly message-only)
<ul>
  <li><strong>Enable Modals: </strong>Allow submissions through pop up modals on the home page. Great for discrete tasks with form fields, like individual forms</li>
  <li><strong>Enable Messages: </strong>Required if the task involves audio/file uploads (e./g. transcription, MOS). Otherwise helpful for piecemeal feeding of tasks, or just to give people another format</li>
</ul>
</li>
<li><strong>Ouput bucket: </strong> empty bucket URL you want your data to be stored in after labeling. By convention, should be input_file_pattern/labelled Again, it has to be a bucket that Mixer has access to.</li>
<li><strong>Budget: </strong> how much do you think users should be paid total/how much is this dataset worth to you? their pay per data point will be set so that this is the total spend.</li>
<li><strong>Label Blocks: </strong> The meat of the taskspec is the label blocks, which can be formed in the <a href='https://app.slack.com/block-kit-builder/T0659MFBXQF'>Slack block kit builder</a>. Use existing taskspecs as templates if necessary. <strong>ONLY USE INPUT BLOCK TYPES</strong>
<ul>
  <li><strong>action_id</strong> becomes the key for this label in the output 'human_labels' dictionary</li>
  <li>For radio/multiselect buttons you can set the option descriptions and the values that get saved for the options separately. The value is what will get saved as action_id: value in the output.</li>
  <li>"Optional" by default is false for a block; if you set it to true then they can skip this block.</li>
  <li>E.g., for allowing the user to provide a plaintext label select a 'plaintext input' block in the Block Builder. You then will see a JSON spec for the block. Set the "action_id" to be the key you want this piece of data stored at (as some data points are labeled in multiple ways). The "text" field can be set to provide additional instructions.</li>
  <li>Once you have your blocks the way you want them, copy paste all the block kit builder JSON into the label blocks text area. Only copy the list (don't include the 'blocks' keyword)</li>
  <li>For examples, please look at existing taskspecs adn pattern match</li>
</ul>
</li>
<li><strong>Output Validation: </strong>For the regex validation field, put in the Python expression that you want to evaluate to true on the data points you accept. The expression should take as input a dictionary with the key you want the regex applied to. For 'chat' tasks, just put the regex, since they are text only. Use chatGPT for complex regexes put test them.</li>
<li><strong>Positive and Negtaive Examples: </strong>For the regex validation field, give some examples of things that should be accepted/rejected and we can validate that your regex passes/fails these accordingly.</li>
<li><strong>Number of Labels: </strong>If you want multiple labels per datapoint for data quality.</li>
<li><strong>Labelling Tier: </strong>The tier is just what level you want to be labeling your task. If you use a lower tier, it should be highly validatable work (strict regexes etc, low creativity) since the quality will probably be lower. Higher tiers have fewer people so might take longer to label but should be higher quality work. You should pay more for higher tiers. The highest tier is gridspacers only.</li>
<li><strong>Number of Labels: </strong>Due date just suggests to the users when the task is due, but it's not enforced yet. Just choose something that will be displayed to the labellers.</li>
<li>Once you save, it will tell you where it's been saved in the taskspec bucket at task_id.json</li>
<li><strong>Adding more data to an existing Task</strong>
  <ul>
  <li>Remove the task from Slack (select the task and select "Remove from Slack")</li>
  <li>Put the additional data into your input bucket.</li>
  <li>The task will appear in dormant tasks; add the task back into Slack. The data will be loaded in except for data points that have already been labeled as many times as originally requested.</li>
  </ul>
  </li>
</ul>

const InstructionModal = () => {
  const [isOpen, setIsOpen] = useState(false);

  const openModal = () => {
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  return (
    <div>
      {!isOpen && <OpenButton onClick={openModal}>View Instructions</OpenButton>}
      <ModalWrapper isOpen={isOpen}>
        <ModalContent>
          <CloseButton onClick={closeModal}>&times;</CloseButton>
          <p>{TaskSpecInstructions}</p>
        </ModalContent>
      </ModalWrapper>
    </div>
  );
};


class SubmitTaskSpec extends React.Component {
    constructor(props) {
      super(props);
      this.handler = this.handler.bind(this);
      this.focus = this.focus.bind(this);
      this.textInput = React.createRef();
      this.state = {
        taskspec: new Object(),
        error_message: '',
        saved: false,
        labelBlocks: '[]',
        activeTaskMetrics: '',
        active: false,
        editing: false,
        submitting: false,
        showSamples: false,
        samples: [],
        nSamples: 10,
        due_date: new Date()
      };
    }

    componentDidMount(){
      if (this.props.taskspec) {
        let ts = JSON.parse(jsonEscape(this.props.taskspec))
        ts.label_blocks = this.props.labelBlocks.replaceAll("&#34;", "\"").replaceAll("&#39;", "\'")
        this.setState({
          taskspec: ts,
          due_date: new Date(parseInt(ts.deadline_timestamp_s, 10)).toLocaleDateString('en-CA'),
          activeTaskMetrics: this.props.activeTaskMetrics,
          active: !(this.props.activeTaskMetrics == ''),
          editing: (this.props.taskspec.task_id == '')
        })
      }
    }

    componentDidUpdate(prevProps) {
        if(prevProps.value !== this.props.value) {
          this.setState({value: this.props.value});
        }
      }

    updateTaskSpec(variable, value) {
      let ts = this.state.taskspec
      ts[variable] = value;
      this.setState({taskspec: ts})
    }

    onTaskpecFormSubmit(e) {
      e.preventDefault();
      e.stopPropagation();
      let data = new FormData(e.target);

      this.updateTaskSpec('deadline_timestamp_s', Date.parse(this.state.due_date))
      data.append("positive_examples", this.state.positive_examples);
      data.append("negative_examples", this.state.negative_examples);
      data.append("enable_modals", this.state.taskspec.enable_modals);
      data.append("enable_messages", this.state.taskspec.enable_messages);
      this.setState({ submitting: true })
      Utils.apiPost("/slack/taskspec/"+this.state.taskspec.task_id, data)
        .then((response) => {
          this.setState({
            taskspec: response.data.taskspec,
            error_message: response.data.error_message,
            message: response.data.message
          });
        })
        .catch((e) => {
          if (e.response && e.response.data) {
            this.setState({
              error_message: e.response.data["message"],
              editing: true
            });
          }
        })
        .finally((x) => this.setState({ submitting: false }));
    }
    handler(e) {
      this.setState({
        prompt: e,
      });
    }
  
    focus(start, end) {
      if (document.activeElement != this.textInput.current) {
        this.textInput.current.focus();
        this.textInput.current.setSelectionRange(start, end);
      }
    }

    getSamples() {
      const task_id = this.state.taskspec.task_id
      Utils.apiGet("/slack/sample_task_responses/"+task_id, {'params': {'no_samples': this.state.nSamples}}).then (
        (response) => {
          this.setState({
              showSamples: true,
              samples: response.data.samples,
            })
          }
      )
    }

    renderSamples() {
      let sampleDicts = this.state.samples.map((sample) => {
        let sampleRendered = Object.entries(sample).map(([key, val]) => {
            return (
              <div>
                <RowFlexDiv>
                  <ColFlexDiv><h3><strong>{key}:</strong></h3></ColFlexDiv>
                </RowFlexDiv>
                <RowFlexDiv>
                  <ColFlexDiv style={{'padding': '10px'}}>
                    <MultiLineText>
                      {val}
                    </MultiLineText>
                  </ColFlexDiv>
                </RowFlexDiv>
              </div>
            )
          })
        return (
          <div style={{'border': '2px solid #1BA69B', 'borderRadius': '2px', 'backgroundColor': 'white', 'padding': '10px', 'margin': '10px'}}>
            {sampleRendered}
          </div>
        )
      })
        
      return (
        <div>{sampleDicts}</div>
      )
    }

    renderActiveTaskMetrics() {
      return (
        <div style={{'marginBottom': '20px'}}>
          <h2>Task In Progess:</h2>
          <MultiLineText>
            {this.props.activeTaskMetrics}
            <div>
              <hr />
              <div>Sample n human labels</div>
              <NumberTextArea
                style={{'margin': '10px'}}
                name="no_samples"
                placeholder="n"
                onChange={(x) => this.setState({'nSamples': x.target.value})}
                value={this.state.nSamples}
              />
              <button onClick={this.getSamples.bind(this)}>Get Samples</button>
              
            </div>
            {this.state.showSamples && <button onClick={() => this.setState({'showSamples': false})}>Hide Samples</button>}
            {!this.state.showSamples && <button onClick={() => this.setState({'showSamples': true})}>Show Samples</button>}
            {this.state.showSamples && this.renderSamples()}
          </MultiLineText>
        </div>
      )
    }

    renderEditForm() {
      return (
        <SessionForm key="session" onSubmit={this.onTaskpecFormSubmit.bind(this)}>
          Please Note:
          <ul>
            <li>Do not use Double Quotes! This will mess up all our jsons and things will be bad. Stick to single quotes please</li>
            <li>The task_id doubles as the Task Name (visible to the labellers) so please use something reasonable</li>
            <li>Use underscores in the task_id for where you want spaces in the name, but please put in the capitalisation.</li>
            <li>Previous examples can be found in 'gs://mixer-scriber-storage/mixer-lab/taskspecs'. Templates are at stoplight.gridspace.com/mixerlab</li>
            <li>To accessa  previous taskspec you've submitted, </li>
          </ul>
          <InputFields>
            <FormField label="Task Name (id)" error={this.state.error}>
              <SessionTextArea
                name="task_id"
                placeholder="task_id"
                onChange={(x) => this.updateTaskSpec('task_id', x.target.value)}
                value={this.state.taskspec.task_id}
                ref={this.textInput}
              />
            </FormField>
            <FormField label="Instructions to Labellers" error={this.state.error}>
              <SessionTextArea
                name="instructions"
                placeholder="instructions"
                onChange={(x) => this.updateTaskSpec('instructions', x.target.value)}
                value={this.state.taskspec.instructions}
                ref={this.textInput}
              />
            </FormField>
            <FormField label="Input File Pattern" error={this.state.error}>
              <SessionTextArea
                name="input_file_pattern"
                placeholder="input_file_pattern"
                onChange={(x) => this.updateTaskSpec('input_file_pattern', x.target.value)}
                value={this.state.taskspec.input_file_pattern}
                ref={this.textInput}
              />
            </FormField>
            <FormField label="Sampling Percentage (between 0 and 1)">
              <NumberTextArea
                name="sample_percentage"
                type="number"
                placeholder=""
                onChange={(x) => this.updateTaskSpec('sample_percentage', x.target.value)}
                value={this.state.taskspec.sample_percentage}
                min="0.01"
                max="1"
                step="0.01"
              />
            </FormField>
            <FormField label="Is it a Training task?">
                <select id="is_training" name="is_training" value={this.state.taskspec.is_training}
                        onChange={(x) => this.updateTaskSpec('is_training', x.target.value)}>
                  <option value={true}>Yes</option>
                  <option value={false}>No</option>
              </select>
            </FormField>
            <FormField label="Slack Label Response Format">
                <select id="response_format" name="response_format"
                        value={this.state.taskspec.response_format}
                        onChange={(x) => this.updateTaskSpec('response_format', x.target.value)}>
                  <option value="chat">Chat (single text response only)</option>
                  <option value="block_submit">Block Submit</option>
              </select>
            </FormField>
            {this.state.taskspec.response_format == 'block_submit' &&
            <div style={{'marginTop': '10px'}}>
              <FormField label="Slack Task Format (For Block Submit Labels, choose whether they can be accessed via the messages tab and/or modal pop-ups)">
                  <input
                    type="checkbox"
                    id='enable_messages'
                    checked={this.state.taskspec.enable_messages}
                    onChange={(x) => this.updateTaskSpec('enable_messages', !this.state.taskspec.enable_messages)} />Enable Messages
              </FormField>
              <div style={{'marginTop': '10px'}}><strong style={{'color': 'red'}}>If your task requires file upload (such as audio), please DO NOT ENABLE MODALS, they won't work.</strong></div>
              <FormField>
                  <input
                    type="checkbox"
                    id='enable_modals'
                    checked={this.state.taskspec.enable_modals}
                    onChange={(x) => this.updateTaskSpec('enable_modals', !this.state.taskspec.enable_modals)} />Enable Modals
              </FormField>
              </div>
            }
            <FormField label="Output Bucket (an EMPTY folder location to store output data points)" error={this.state.error}>
              <SessionTextArea
                name="output_bucket"
                placeholder=""
                onChange={(x) => this.updateTaskSpec('output_bucket', x.target.value)}
                value={this.state.taskspec.output_bucket}
                ref={this.textInput}
              />
            </FormField>
            <div>
              <FormField label="Budget">
                <NumberTextArea
                  name="budget"
                  type="number"
                  placeholder=""
                  onChange={(x) => this.updateTaskSpec('budget', x.target.value)}
                  value={this.state.taskspec.budget}
                  min="0"
                  max="5000"
                  step="1"
                />
              </FormField>
              {(this.state.taskspec.response_format === 'block_submit') && 
                <FormField label="Label Blocks">
                  <a href='https://app.slack.com/block-kit-builder/T0659MFBXQF' target="_blank">Design your label blocks here</a>
                  Then copy and paste them below. To evaluate things
                  <SessionTextArea
                    name="label_blocks"
                    placeholder=""
                    onChange={(x) => this.updateTaskSpec('label_blocks', x.target.value)}
                    value={this.state.taskspec.label_blocks}
                    ref={this.textInput}
                  />
                </FormField>
              }
              <FormField label="Expressions for block submit output validation" error={this.state.error}>
                Newline separated. Give as dictionary, as in the example below
                <SessionTextArea
                  name="output_criteria"
                  placeholder='{"regex": r"\\b(?:[0-1][0-9]|2[0-3]):[0-5][0-9]\\b", "key": "time"}'
                  onChange={(x) => this.updateTaskSpec('output_criteria', x.target.value)}
                  value={this.state.taskspec.output_criteria}
                  ref={this.textInput}
                />
              </FormField>
              {(this.state.taskspec.response_format === 'chat') && 
                <div>
                  <FormField label="Regex for Text Output Format Validation" error={this.state.error}>
                    <SessionTextArea
                      name="output_data_regex"
                      placeholder="^.*\\bchristmas\\b"
                      onChange={(x) => this.updateTaskSpec('output_data_regex', x.target.value)}
                      value={this.state.taskspec.output_data_regex}
                      ref={this.textInput}
                    />
                  </FormField>
                  <FormField label="Positive examples for Regex test" error={this.state.error}>
                    <SessionTextArea
                      name="positive_examples"
                      placeholder="New line separated examples"
                      onChange={(x) => this.setState({ positive_examples: x.target.value })}
                      value={this.state.positive_examples}
                      ref={this.textInput}
                    />
                  </FormField>
                  <FormField label="Negative examples of regex test" error={this.state.error}>
                    <SessionTextArea
                      name="negative_examples"
                      placeholder="New line separated examples"
                      onChange={(x) => this.setState({ negative_examples: x.target.value })}
                      value={this.state.negative_examples}
                      ref={this.textInput}
                    />
                  </FormField>
                </div>
              }
              <FormField label="Number of Times you want each datapoint Labelled (for robustness)">
                <NumberTextArea
                  name="labels_per_datapoint"
                  type="number"
                  placeholder=""
                  onChange={(x) => this.updateTaskSpec('labels_per_datapoint', x.target.value)}
                  value={this.state.taskspec.labels_per_datapoint}
                  min="1"
                  max="500"
                  step="1"
                />
              </FormField>
              <FormField label="Labelling Tier (0-4)">
                <a>Higher tier = higher quality but longer time.</a>
                <select value={this.state.taskspec.labelling_tier} 
                        id="labelling_tier" name="labelling_tier" 
                        onChange={(x) => this.updateTaskSpec('labelling_tier', x.target.value)}>
                    <option value="1">1: Low (Spell checking/grammar only tbh)</option>
                    <option value="2">2: Mid-Low (Easy Tasks)</option>
                    <option value="3">3: Mid (Some complexity)</option>
                    <option value="4">4: High (Nuanced tasks)</option>
                    <option value="5">5: Highest (One person, personal contact)</option>
                    <option value="6">inf: Gridspacers (use for trialling new tasks)</option>
                </select>
              </FormField>
              <FormField label="Due Date">
                <NumberTextArea
                  name="deadline_timestamp_s"
                  type="date"
                  onChange={(x) => this.setState({due_date: x.target.value})}
                  value={this.state.due_date}
                />
              </FormField>
            </div>
            {!this.state.submitting &&
              <SubmitRow>
                <button type="submit" name="save">
                  Save TaskSpec
                </button>
              </SubmitRow>
            }
          </InputFields>
          <MultiLineText style={{'color': 'red'}}>{this.state.error_message}</MultiLineText>
          <MultiLineText style={{'color': 'blue'}}>{this.state.message}</MultiLineText>
        </SessionForm>
      )
    }

    taskActionHandler(action) {
      const task_id = this.state.taskspec.task_id
      this.setState({ submitting: true })
      Utils.apiPost("/slack/"+action+"/"+task_id).then (
        (response) => {
          if (response.data.result === 'success') {
            window.location.reload()
          }
          else {
              this.setState({
              submitting: false,
              error_message: response.data.message
            })
          }
        }
      )}

    render() { 
      let ts = this.state.taskspec;
      let task_details = Object.entries(ts).map(([key, val]) => {
        if ((key !== 'label_fields') && (key !== 'label_blocks')) {
          return (
            <RowFlexDiv>
              <h3><strong>{key}:</strong></h3>
              <MultiLineText style={{'marginLeft': '10px'}}>
                {String(val)}
              </MultiLineText>
            </RowFlexDiv>
          )
        }
      })

      return (
        <PageWrapper isAdmin={this.props.isAdmin} style={{ display: "flex", flexDirection: "row" }}>
          <InstructionModal />
          <div style={{ display: "flex", flexDirection: "column" }}>
            {this.state.active && this.renderActiveTaskMetrics()}
            <h2>Task Details</h2>
            {task_details}
            {<div>
              <h3>Label Blocks:</h3>
              <MultiLineText>{ts['label_blocks']}</MultiLineText>
            </div>}
            {(this.state.editing && !(this.state.active)) && this.renderEditForm()}
            {this.state.submitting && 
              <GridspaceLoadingIcon></GridspaceLoadingIcon>
            }
            {!this.state.submitting && 
            <div style={{'margin': '10px'}}>
              {this.state.error_message}
              <button disabled={(this.state.active)} name="edit" onClick={() => this.setState({editing: !(this.state.editing)})}>
                Edit TaskSpec
              </button>
              <button disabled={this.state.editing || this.state.active} name="submit"
                        onClick={() => this.taskActionHandler('submit_task')}>
                Submit to Slack
              </button>
              <button disabled={!(this.state.active)} name="remove"
                                  onClick={() => this.taskActionHandler('remove_task')}>
                Remove From Slack
              </button>
            </div>
            }
          </div>
        </PageWrapper>
      );
    }
  }



export default SubmitTaskSpec